import http from "../http-common";

class SaleDataService {
    getAll(params = {}) {
        return http.get('/sales', { params });
    }

    get(id) {
        return http.get(`/sales/${id}`);
    }

    create(data) {
        return http.post('/sales', data);
    }

    update(id, data) {
        return http.put(`/sales/${id}`, data);
    }

    delete(id) {
        return http.delete(`/sales/${id}`);
    }

    getStatistics(params = {}) {
        return http.get('/sales-statistics', { params });
    }
}

export default new SaleDataService();
